<template>
  <div>
    <logged-in-header />
    <buy-now-pay-later-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import buyNowPayLaterPanel from "../components/buy-now-pay-later/BuyNowPayLaterPanel";

export default {
  components: {
    loggedInHeader,
    buyNowPayLaterPanel
  }
};
</script>
